export default __webpack_public_path__ + "static/media/logoWebCore-bk.2fd795c4.svg";